// extracted by mini-css-extract-plugin
module.exports = {"chip":"widget-demo--chip--1QC08","content":"widget-demo--content--3WECU","action":"widget-demo--action--NA09_"};